import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons'
import type { FC } from 'react'

import ActionButton from '@/components/ActionButton'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const ReopenButton: FC<Props> = ({ onClick, disabled = false }) => (
  <ActionButton
    label="Reopen"
    icon={faArrowsRotate}
    onClick={onClick}
    disabled={disabled}
  />
)

export default ReopenButton
